import type { PaginationMeta } from '../../../types/pagination';
import type { Uuid } from './common';

export const INVENTORY_CATEGORIES = ['lab', 'sports', 'books', 'material', 'other'] as const;
export type InventoryCategory = (typeof INVENTORY_CATEGORIES)[number];

export interface InventoryItemSummary {
  id: Uuid;
  code: string;
  name: string;
  category: string;
  unit?: string | null;
  vendor_id?: Uuid | null;
  min_stock_qty: number;
  current_stock_qty: number;
}

export interface ListInventoryItemsResponse extends PaginationMeta {
  items: InventoryItemSummary[];
}

export interface CreateInventoryItemRequest {
  code: string;
  name: string;
  category: InventoryCategory | string;
  unit?: string | null;
  vendor_id?: string | null;
  min_stock_qty?: number | null;
  opening_stock_qty?: number | null;
}

export interface AddInventoryStockRequest {
  item_id: string;
  quantity: number;
  notes?: string | null;
}

export interface IssueInventoryStockRequest {
  item_id: string;
  quantity: number;
  reference_type?: string | null;
  reference_id?: string | null;
  notes?: string | null;
}

export interface ReturnInventoryStockRequest {
  item_id: string;
  quantity: number;
  reference_type?: string | null;
  reference_id?: string | null;
  notes?: string | null;
}

export interface InventoryStockMovementResponse {
  movement_id: Uuid;
  item_id: Uuid;
  current_stock_qty: number;
}

export interface InventoryMovementSummary {
  id: Uuid;
  item_id: Uuid;
  movement_type: string;
  quantity: number;
  reference_type?: string | null;
  reference_id?: string | null;
  notes?: string | null;
  created_at: string;
}

export interface ListInventoryMovementsResponse extends PaginationMeta {
  movements: InventoryMovementSummary[];
}
